import {
  adminControlFeatures,
  codeScanningFeatures,
  complianceFeatures,
  deploymentFeatures,
  type FullTierDescription,
  mainFeatures,
  qualityFeatures,
  reportingFeatures,
  sbomFeatures,
  securityFeatures,
  supportFeatures,
} from './consts';

const freeTierFeatures: FullTierDescription = {
  mainFeatures: {
    [mainFeatures.projectsFeature]: '5',
    [mainFeatures.releaseGroupsFeature]: '1',
    [mainFeatures.continuousMonitoringFeature]: true,
    [mainFeatures.apiSupportFeature]: true,
    [mainFeatures.packageIndexFeature]: false,
    [mainFeatures.issueDashboardFeature]: true,
    [mainFeatures.autoIgnoreRulesFeature]: false,
    [mainFeatures.issueFiltersFeature]: 'Limited',
    [mainFeatures.savedFiltersFeature]: false,
  },
  codeScanningFeatures: {
    [codeScanningFeatures.sourceCodeScanningFeature]: true,
    [codeScanningFeatures.deepDepDiscoveryFeature]: true,
    [codeScanningFeatures.quickImportGitHubFeature]: true,
    [codeScanningFeatures.cicdIntegrationFeature]: true,
    [codeScanningFeatures.branchTagScanningFeature]: false,
    [codeScanningFeatures.containerScanningFeature]: true,
    [codeScanningFeatures.policyScanDepthLevelsFeature]: '5',
    [codeScanningFeatures.dependencyScanDepthLevelsFeature]: 'Unlimited',
  },
  securityFeatures: {
    [securityFeatures.vulnIdentificationFeature]: '5 Depth Limit',
    [securityFeatures.vulnManagementFeature]: 'Limited',
    [securityFeatures.defaultSecurityPoliciesFeature]: true,
    [securityFeatures.customizeableSecurityPoliciesFeature]: false,
    [securityFeatures.basicIssueFilterSortFeature]: true,
    [securityFeatures.advancedIssueFilterSortFeature]: false,
  },
  complianceFeatures: {
    [complianceFeatures.licenseIdentificationFeature]: true,
    [complianceFeatures.licensingPolicyManagementFeature]: true,
    [complianceFeatures.defaultLicensePoliciesFeature]: true,
    [complianceFeatures.customizeableLicensePoliciesFeature]: false,
  },
  qualityFeatures: {
    [qualityFeatures.packageHealthSignalsFeature]: 'Outdated Packages Only',
    [qualityFeatures.defaultQualityPoliciesFeature]: true,
    [qualityFeatures.customizeableQualityPoliciesFeature]: false,
  },
  sbomFeatures: {
    [sbomFeatures.sbomGenerationFeature]: true,
    [sbomFeatures.sbomImportFeature]: '5',
    [sbomFeatures.vexAnnotationsFeature]: false,
    [sbomFeatures.appSbomFeature]: true,
    [sbomFeatures.publicSbomFeature]: true,
    [sbomFeatures.privateSbomFeature]: false,
  },
  reportingFeatures: {
    [reportingFeatures.attributionReportFeature]: true,
    [reportingFeatures.auditDueDiligenceReportFeature]: false,
    [reportingFeatures.vulnReportFeature]: 'Deprecated',
    [reportingFeatures.globalBundleFeature]: false,
    [reportingFeatures.issueOverviewFeature]: false,
    [reportingFeatures.complianceReportFeature]: true,
    [reportingFeatures.licensePackageReportFeature]: true,
  },
  adminControlFeatures: {
    [adminControlFeatures.auditLogsFeature]: false,
    [adminControlFeatures.jiraIntegrationFeature]: false,
    [adminControlFeatures.slackIntegrationFeature]: false,
    [adminControlFeatures.ssoFeature]: false,
    [adminControlFeatures.teamFeature]: false,
    [adminControlFeatures.rbacFeature]: false,
  },
  supportFeatures: {
    [supportFeatures.basicEmailFeature]: true,
    [supportFeatures.priorityEmailFeature]: false,
    [supportFeatures.onboardingAndSupportFeature]: false,
    [supportFeatures.slaFeature]: false,
  },
  deploymentFeatures: {
    [deploymentFeatures.saasDeploymentFeature]: true,
    [deploymentFeatures.managedSaasDeploymentFeature]: false,
    [deploymentFeatures.onPremDeploymentFeature]: false,
  },
};

export default freeTierFeatures;
